import Axios from 'axios';
import { StoreModel } from '../models/StoreModel';
import { API_ADMIN } from '@/utils/constants/Api';
import { orderBy } from 'lodash';

export default {
    getStores(): Promise<StoreModel[]> {
        return Axios.get(`${API_ADMIN}stores`)
            .then(({data}) => {
                const storeList = data.map((s: StoreModel) => new StoreModel(s))

                return orderBy(storeList, ['name'], ['asc'])
            })
    }
}
